import { useState } from "react";
import {
  LABEL_APPLIACE_NAME,
  LABEL_JOB,
} from "../../../constant/label_constant";
import MyDataTable from "../../../component/MyDataTable";
import moment from "moment";
import { useSelector } from "react-redux";
import { CALL_AWAITING_APPROVAL_ON_SF } from "../../../constant/action_permission";
import MainBody from "../../../component/MainBody";
import ApproveAssignBooking from "./ApproveAssignBooking";
import { EMPLOYEE_TYPE } from "../../../constant/status_constant";

const AwatingOnSFApproval = () => {
  const [formData, setFormData] = useState({});
  const [reloadList, setReload] = useState(true);
  const [isOpenForm, setOpenForm] = useState(false);
  let loggedInUser = useSelector((state) => state.authReducer.currentUser);

  const closeForm = () => {
    setOpenForm(false);
    setFormData({});
  };

  const calculateDateDifference = (givenDate) => {
    const currentDate = new Date();
    const selectedDate = new Date(givenDate);

    // Calculate the difference in milliseconds
    const differenceInMilliseconds = Math.abs(selectedDate - currentDate);

    // Calculate the difference in days
    const differenceInDays = Math.floor(
      differenceInMilliseconds / (1000 * 60 * 60 * 24)
    );

    return differenceInDays;
  };

  const columns = [
    {
      name: "SNo.",
      selector: (row) => "", // Placeholder, as we don't need to select data from the row itself
      cell: (row, index) => index + 1, // Use cell to render the incrementing number
    },
    {
      name: "Booking ID",
      selector: (row) => row.booking_id,
      // cell: (row) => (
      //   <NavLink to={`/getbookingdetails?bid=${btoa(row.id)}`}>
      //     {row.booking_id}
      //   </NavLink>
      // ),
    },
    {
      name: <div className="word-wrap">{LABEL_APPLIACE_NAME}</div>,
      selector: (row) => row.appliance["appliance_name"],
      wrap: true,
    },
    {
      name: <div className="word-wrap">{LABEL_JOB + " Type"}</div>,
      selector: (row) => row.calltype_group["type"],
      wrap: true,
    },
    {
      name: <div className="word-wrap">Customer Name</div>,
      wrap: true,
      selector: (row) => row.user_detail.customer_name,
    },
    {
      name: "Customer City",
      wrap: true,
      selector: (row) => row?.booking_city,
      cell: (row) => (
        <div className="word-wrap">
          {row?.booking_city + " / " + row.booking_pincode}
        </div>
      ),
    },
    Number(loggedInUser.entity_type) === EMPLOYEE_TYPE && {
      name: <div className="word-wrap">ASC Name</div>,
      selector: (row) => row?.booking_assigneds?.[0]?.service_centre?.display_name || 'N/A',
      wrap: true,
    },
    {
      name: <div className="word-wrap">{LABEL_JOB + " Date"}</div>,
      selector: (row) => moment(row.booking_date).format("DD-MMM-YYYY"),
      cell: (row) => (
        <div className="word-wrap">
          {moment(row.booking_date).format("DD-MMM-YYYY")}
        </div>
      ),
      wrap: true,
    },
    {
      name: "Ageing",
      selector: (row) =>
        calculateDateDifference(row.booking_initial_date) + " Days",
      cell: (row) =>
        calculateDateDifference(row.booking_initial_date) + " Days",
    },
    CALL_AWAITING_APPROVAL_ON_SF.includes(loggedInUser.role_id) && {
      name: "Approve",
      cell: (row) => (
        <>
          <button
            target={"_blank"}
            className="btn btn-sm btn-success"
            onClick={() => {
              setFormData({bid: row.bid, action: 1, booking_date: moment(row.booking_date).format("DD-MMM-YYYY"),
               sf_id: row?.booking_assigneds?.[0]?.sf_id, pid: row?.booking_assigneds?.[0]?.id})
              setOpenForm(true);
            }}
          >
            <i className="fas fa-check" />
          </button>
        </>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      exportXlsx: false,
    },
    CALL_AWAITING_APPROVAL_ON_SF.includes(loggedInUser.role_id) && {
      name: "Reject",
      cell: (row) => (
        <>
          <button
            target={"_blank"}
            className="btn btn-sm btn-danger"
            onClick={() => {
              setFormData({bid: row.bid, action: 2,booking_date: moment(row.booking_date).format("DD-MMM-YYYY"),
               sf_id: row?.booking_assigneds?.[0]?.sf_id, pid: row?.booking_assigneds?.[0]?.id})
              setOpenForm(true);
            }}
          >
            <i className="fas fa-check" />
          </button>
        </>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      exportXlsx: false,
    },
  ].filter(Boolean);

  return (
    <div>
      <MainBody
        breadcrumbTitle={`${LABEL_JOB} On Approval for Assignment`}
        breadcrumbSubTitle={"List"}
        navButton={""}
        title={""}
        component={
          <>
            <section className="content">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-12">
                    <div className="card">
                      <div className="card-header">
                        <h3 className="card-title">
                          {LABEL_JOB} On Approval for Assignment
                        </h3>
                      </div>
                      <MyDataTable
                        reloadList={reloadList}
                        columns={columns}
                        getDataListURL={`getbookingforapprovalonsf?`}
                        setReload={setReload}
                        exportName={"pendinglist"}
                      />
                    </div>
                  </div>
                </div>
              </div>
              {isOpenForm && (
                <ApproveAssignBooking
                  formData={formData}
                  setFormData={setFormData}
                  closeForm={closeForm}
                  setReload={setReload}
                  
                />
              )}
            </section>
          </>
        }
      />
    </div>
  );
};

export default AwatingOnSFApproval;
